import React from 'react'
import { connect } from 'react-redux'
//import { firestoreConnect } from 'react-redux-firebase'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Redirect, NavLink } from 'react-router-dom'



const JournalDetails = (props) => {
  const { journal, auth } = props;
  if (!auth.uid) return <Redirect to='/signin' /> 
  if (journal) {
    let preview = "No Log Text";
    const comments = new Array();
    if (journal.logText !== undefined) {
      var keys = Object.keys(journal.logText);
      console.log(keys);
      if (keys.length > 0) {
        var key = keys[0];
        var logText = journal.logText[key];
        if (logText.en !== undefined) {
          preview = logText.en;
        }
        
        for (var i = 0; i < keys.length; i++) {

          logText = journal.logText[keys[i]];
          var type = "text"
          var logtextUser = ""
          if (logText["logType"] !== undefined) {
              type = logText["logType"]
          }
          if (logText["userID"] !== undefined) {
              logtextUser = logText["userID"]
          }
          if ((comments.length === 0) || (comments[comments.length - 1].user !== logtextUser)) {
              //This is a new comment.  Make a new comment and add to the array
              let comment = {}
              comment.user = logtextUser
              var firstName = ""
              var lastName = ""
              if ((logText["firstName"]) !== undefined) {
                  firstName = logText["firstName"]
              }
              if ((logText["lastName"]) !== undefined) {
                  lastName = logText["lastName"]
              }
              comment.userName = firstName + " " + lastName
              var firstInitial = ""
              var lastInitial = ":"
              if (firstName !== undefined && firstName.length > 0) {
                  firstInitial = firstName.charAt(0);
              }
              if (lastName !== undefined && lastName.length > 0) {
                  lastInitial = lastName.charAt(0);
              }
              comment.userInitials = firstInitial + lastInitial;
              comments.push(comment);
          }
          //Get the last comment out of the array and append the text.
          let lastComment = comments[comments.length - 1]
          if ((type === "text") || (type === "announcement")) {
              var englishText = ""
              
              if (logText["en"] !== undefined) {
                  englishText = logText["en"]
              }
              var spanishText = ""
              if (logText["es"] !== undefined) {
                  spanishText = logText["es"]
              }
              
              if (lastComment.englishText !== undefined && lastComment.englishText.length > 0 && englishText.length > 0) {
                  lastComment.englishText += "<br/>";
              }
              if (lastComment.spanishText !== undefined && lastComment.spanishText.length > 0 && spanishText.length > 0) {
                  lastComment.spanishText += "<br/>";
              }
              lastComment.englishText = lastComment.englishText === undefined ? englishText : lastComment.englishText + englishText
              lastComment.spanishText = lastComment.spanishText === undefined ? spanishText : lastComment.spanishText + spanishText
              
              
          } else if (type === "image") {
              
              if (logText["downloadUrl"] !== undefined) {
                if (lastComment.images === undefined) {
                  lastComment.images = new Array();
                }
                lastComment.images.push(logText["downloadUrl"]);
                  
              }
          } else if (type === "video") {
              if (logText["downloadUrl"] !== undefined) {
                if (lastComment.images === undefined) {
                  lastComment.images = new Array();
                }
                let vString =  "v_" + (logText["downloadUrl"]);
                lastComment.images.push(vString)
                  
              }
          } else if (type === "weather") {
              if (logText["body"] !== undefined) {
                  lastComment.weatherBody = logText["body"];
              }
          }
          
        }
      }
    }
    //for (var key in keys) 
    return (
      <div className="container section project-details">
        <div className="card z-depth-0">
          <div className="card-content">
            <span className="card-title">{journal.tapeID}</span>
            
          </div>
          <div>
          {journal.locationProject === undefined ? '' : journal.locationProject}<br/>
          {journal.locationHierarchy === undefined ? '' : journal.locationHierarchy}<br/>
          
          

          { comments && comments.map(comment => {
            return (
              <div>
              <NavLink to='/' className="btn btn-floating green lighten-1">
                {comment.userInitials}
              </NavLink>
              <br/>
              <div><p dangerouslySetInnerHTML={{__html: comment.englishText !== undefined ? comment.englishText : ""}}></p></div>
              
              
              <div><p dangerouslySetInnerHTML={{__html: comment.spanishText !== undefined ? comment.spanishText : ""}}></p></div>
              </div>
            )
            })} 
          </div>
          
        </div>
      </div>
    )
  } else {
    return (
      <div className="container center">
        <p>Loading journal...</p>
      </div>
    ) 
  }
}

const mapStateToProps = (state, ownProps) => {
  console.log(state);
  const id = ownProps.match.params.id;

  const journal = state.firebase.data.tapes[id];
  return {
    id: ownProps.match.params.id,
    auth: state.firebase.auth,
    journal: journal
  }
}

export default compose(
  connect(mapStateToProps),
  firebaseConnect([
    {path: 'tapes'}
  ])
)(JournalDetails)



// WEBPACK FOOTER //
// ./src/components/journals/JournalDetails.js